import script from "./TableChips.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableChips.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__